export default "<i class=\"fas fa-plus original-fa-plus\" (click)=\"propagateClick  == 'true' && creatItem()\"></i>\r\n"